<div class="top-bar">
    <div class="select-button-container">
        <p-selectButton [options]="displayOptions" [(ngModel)]="selectedDisplayOption"
            (onChange)="doMultiFilterSearch(0)">
        </p-selectButton>
    </div>
</div>
<p-table *ngIf="searchForm" [value]="bookingRequests" [lazy]="true" (onLazyLoad)="lazyLoad($event)" [paginator]="true"
    [style]="{width: '1680px'}" [loading]="loading" [rows]="recordsByPage" [totalRecords]="totalRecords"
    [rowsPerPageOptions]="pageRecordsOptions" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
    <ng-template pTemplate="header">
        <tr>
            <th [style]="{'width':'60px'}">
                ID
            </th>
            <th>
                Name
            </th>
            <th>
                Programme
            </th>
            <th [style]="{'width':'180px'}">
                Start
            </th>
            <th [style]="{'width':'180px'}">
                End
            </th>
            <th [style]="{'width':'80px'}">
                Duration
            </th>
            <th [style]="{'width':'120px'}">
                Agent
            </th>
            <th [style]="{'width':'180px'}">
                Received
            </th>
        </tr>
        <tr [formGroup]="searchForm">
            <th></th>
            <th>
                <input pInputText formControlName="name" (input)="updateStringFilter($event)">
            </th>
            <th>
                <input pInputText formControlName="programmeName" (input)="updateStringFilter($event)">
            </th>
            <th>
                <p-calendar appendTo="body" formControlName="startDate" [monthNavigator]="true" [yearRange]="yearRange"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="doMultiFilterSearch(0)"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </th>
            <th>
                <p-calendar appendTo="body" formControlName="endDate" [monthNavigator]="true" [yearRange]="yearRange"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="doMultiFilterSearch(0)"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </th>
            <th>
                <input pInputText [style]="{'width': '60px'}" formControlName="duration"
                    (input)="updateDurationFilter($event)">
            </th>
            <th>
                <p-dropdown appendTo="body" [showClear]="true" placeholder="Select" (onChange)="doMultiFilterSearch(0)"
                    [options]="salesAgents" formControlName="agent" optionLabel="name" [style]="{'min-width': '90px'}">
                </p-dropdown>
            </th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-request>
        <tr [pSelectableRow]="request">
            <td>
                {{request.id}}
            </td>
            <td>
                <a routerLink="/management/wp-booking-request-edit/{{request.id}}">
                    {{request.firstName}} {{request.familyName}}
                </a>
            </td>
            <td>
                {{request.programme}}
            </td>

            <td>
                <p>
                    {{request.startDay | date:'dd/MM/yyyy'}}
                </p>
            </td>
            <td>
                <p>
                    {{request.endDay | date:'dd/MM/yyyy'}}
                </p>
            </td>
            <td>
                <p>
                    {{request.duration}}
                </p>
            </td>
            <td>
                <p *ngIf="request.agent">
                    {{request.agent.name}}
                </p>
            </td>
            <td>
                {{request.created | date:"dd/MM/yyyy HH:mm"}}
            </td>
        </tr>
    </ng-template>
</p-table>